import DescriptionIcon from '@mui/icons-material/Description';
import { useTheme } from '@mui/material';

export const Contract = ({ size = 'large' }) => {
  const theme = useTheme();

  return (
    <DescriptionIcon
      fontSize={size}
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
